export const formatNumberDK = (n?: number | string | null) => {
  if (typeof n === 'number') return new Intl.NumberFormat('da-DK').format(n);
  if (typeof n === 'string' && n.trim().length > 0) {
    const parsed = Number(n.replace(/\s/g, ''));
    return Number.isFinite(parsed) ? new Intl.NumberFormat('da-DK').format(parsed) : n;
  }
  return '';
};
